import { render, staticRenderFns } from "./AttachmentCards.vue?vue&type=template&id=651e709b"
import script from "./AttachmentCards.vue?vue&type=script&lang=js"
export * from "./AttachmentCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports